/**
 * @module StepIdentificacion
 * @description Paso 1 del flujo de pagos en línea.
 * Permite al usuario seleccionar su tipo de documento de identidad
 * e ingresar su número de documento.
 *
 * Los tipos de documento se cargan dinámicamente desde el backend
 * al montar el módulo (ver PagosOnlineContext).
 *
 * Este componente está envuelto por data-kt-stepper-element="content"
 * para que StepperComponent lo gestione como contenido del paso 1.
 */

import { FC } from "react";
import { usePagosOnline } from "../PagosOnlineContext";

const StepIdentificacion: FC = () => {
  const {
    estado,
    setEstado,
    tiposDocumentosDisponibles,
    tipo_docu,
    documento,
  } = usePagosOnline();

  /**
   * Actualiza el tipo de documento seleccionado en el estado global.
   * @param event - Evento de cambio del select HTML
   */
  const handleTipoDocumentoChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const newState = { ...estado, tipoDocumento: event.target.value };
    setEstado(newState);
  };

  /**
   * Actualiza el número de documento ingresado en el estado global.
   * @param event - Evento de cambio del input HTML
   */
  const handleDocumentoChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newState = { ...estado, documento: event.target.value };
    setEstado(newState);
  };

  return (
    <div className="current row" data-kt-stepper-element="content">
      <div className="">
        {/* Selector de tipo de documento (C.C, T.I, NIT, C.E, R.E) */}
        <div className="row mt-3">
          <div className="col">
            <label>
              <b>Tipo documento:</b>{" "}
            </label>
            <select
              className="form-select rounded-pill"
              id="select_tipo_doc"
              ref={tipo_docu}
              value={estado.tipoDocumento}
              onChange={handleTipoDocumentoChange}
            >
              {tiposDocumentosDisponibles &&
                tiposDocumentosDisponibles.length > 0 &&
                tiposDocumentosDisponibles.map((doc, index) => {
                  return (
                    <option key={index} value={doc.codigo}>
                      {doc.abreviatura + " - " + doc.descripcion}
                    </option>
                  );
                })}
            </select>
          </div>
        </div>

        {/* Campo de número de documento con límite de 14 caracteres */}
        <div className="row mt-6">
          <div className="col">
            <label>
              <b>Número de documento:</b>{" "}
            </label>
            <input
              type="text"
              className="form-control form-control-lg rounded-pill"
              id="input_documento"
              maxLength={14}
              placeholder="Numero de documento"
              ref={documento}
              value={estado.documento}
              onChange={handleDocumentoChange}
            ></input>
          </div>
        </div>
      </div>
    </div>
  );
};

export { StepIdentificacion };
